import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { EmployeeService } from 'src/app/services/employee.service';
import { UtilsService } from 'src/app/services/utils.service';
import { PermissionService } from 'src/app/services/permission.service';

@Component({
    selector: 'app-health-tab',
    templateUrl: './health-tab.component.html',
    styleUrls: ['./health-tab.component.css', '../employee-tab-shared.css']
})
export class HealthTabComponent implements OnInit {
    @Input() employee: any;
    @Output() saved = new EventEmitter<any>();

    form!: FormGroup;
    readonly maxHealthRestrictionsLength = 500;

    constructor(
        private fb: FormBuilder,
        private employeeService: EmployeeService,
        private utils: UtilsService,
        private spinner: NgxSpinnerService,
        private permissionService: PermissionService
    ) { }

    canDo(action: string): boolean {
        return this.permissionService.canDo('Listado de colaboradores', action);
    }

    ngOnInit(): void {
        this.form = this.fb.group({
            health_restrictions: [this.employee?.health_restrictions || '', Validators.maxLength(this.maxHealthRestrictionsLength)],
            emergency_contact_name: [this.employee?.emergency_contact_name || ''],
            emergency_contact_phone: [this.employee?.emergency_contact_phone || '']
        });
    }

    save(): void {
        const payload = this.form.value;

        this.spinner.show();
        this.employeeService.update(this.employee.id, payload).subscribe({
            next: (resp: any) => {
                this.spinner.hide();
                this.utils.alertSwal({ title: 'Operación exitosa', text: 'La información de salud se guardó correctamente', icon: 'success' });
                this.saved.emit(resp);
            },
            error: () => {
                this.spinner.hide();
                this.utils.alertSwal({ title: 'Error', text: 'No se pudo guardar la información', icon: 'error' });
            }
        });
    }
}
